import { takeLatest, put, call, all, takeEvery, select } from 'redux-saga/effects';
import isEmpty from 'lodash/isEmpty';
import { getMessageContent } from 'yoda-interfaces/lib/Content/ContentApi';
import {
    FIND_STORES_NEW_ORDER_MESSAGE,
    SET_SERVICE_ERROR,
} from 'yoda-site-components/lib/common/Constants';
import { HOLIDAY_BOPIS_MESSAGE_CONTENT } from '../common/Constants';

import * as actionTypes from '../actionTypes/MessageContentActionTypes';

function* handleBopisMessageFallBack() {
    const messageContent = {
        body: FIND_STORES_NEW_ORDER_MESSAGE,
        id: HOLIDAY_BOPIS_MESSAGE_CONTENT,
    };
    yield put({ type: actionTypes.GET_MESSAGE_CONTENT_SUCCESS, messageContent });
}

function* messageContentSaga(action) {
    const context = (state) => state.context;
    const appContext = yield select(context);
    const { enableCoreMediaContent = true } = appContext?.featureFlags || {};
    const genericErrorObj = {
        errorComponent: 'CART_SECTION',
        errorCode: 'GENERIC_API_ERROR',
        errorMessage: 'There was an error while processing your request. Please try again.',
    };
    try {
        const { supportMultiZoneData } = action.payload;
        const modifyAction = action;
        modifyAction.payload = action.payload.type;
        if (enableCoreMediaContent) {
            modifyAction.isCMHeaderRequired = true;
        }
        let messageContent = yield call(getMessageContent, modifyAction, supportMultiZoneData);
        if (messageContent.status === 200) {
            yield put({ type: actionTypes.GET_MESSAGE_CONTENT_SUCCESS, messageContent });
        } else if (enableCoreMediaContent && messageContent.status !== 200) {
            modifyAction.isCMHeaderRequired = false;
            messageContent = yield call(getMessageContent, modifyAction, supportMultiZoneData);
            yield put({ type: actionTypes.GET_MESSAGE_CONTENT_SUCCESS, messageContent });
        } else if (modifyAction.payload === HOLIDAY_BOPIS_MESSAGE_CONTENT) {
            yield call(handleBopisMessageFallBack);
        } else {
            yield put({ type: SET_SERVICE_ERROR, errorHandlerInfo: genericErrorObj });
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error in getting the content for ');
        if (action.payload === HOLIDAY_BOPIS_MESSAGE_CONTENT) {
            yield call(handleBopisMessageFallBack);
        } else {
            const errorInfo = !isEmpty(error) ? error : genericErrorObj;
            yield put({ type: SET_SERVICE_ERROR, errorHandlerInfo: errorInfo });
        }
    }
}

function* holidayMessageContentSaga(action) {
    const context = (state) => state.context;
    const appContext = yield select(context);
    const { enableCoreMediaContent = true } = appContext?.featureFlags || {};
    const modifyAction = action;
    if (enableCoreMediaContent) {
        modifyAction.isCMHeaderRequired = true;
    }
    let messageContent = yield call(getMessageContent, modifyAction);
    if (messageContent.status === 200) {
        yield all([
            put({ type: actionTypes.GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_SUCCESS, messageContent }),
        ]);
    } else if (enableCoreMediaContent && messageContent.status !== 200) {
        modifyAction.isCMHeaderRequired = false;
        messageContent = yield call(getMessageContent, modifyAction);
        yield all([
            put({ type: actionTypes.GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_SUCCESS, messageContent }),
        ]);
    }
}

const watchMessageContent = function* watchMessageContent() {
    yield takeEvery(actionTypes.GET_MESSAGE_CONTENT_REQUEST, messageContentSaga);
};
watchMessageContent.sagaName = 'watchMessageContent';

const watchBopisHolidayMessageContent = function* watchBopisHolidayMessageContent() {
    yield takeLatest(
        actionTypes.GET_BOPIS_HOLIDAY_MESSAGE_CONTENT_REQUEST,
        holidayMessageContentSaga
    );
};
watchBopisHolidayMessageContent.sagaName = 'watchBopisHolidayMessageContent';

export { watchMessageContent, watchBopisHolidayMessageContent };
